export const getInstrument = {
    "apm": "https://getinstrumentdetailsv2-4aukegs6fq-uc.a.run.app",
    "vide": "https://getinstrumentdetailsv2-muifqziswa-uc.a.run.app",
    "betatrader": "https://btapi.videalpha.com/api/instrumentdetails",
    "goldpro": "https://getinstrumentdetailsv2-vjesznhqxa-uc.a.run.app"
}
export const historicalApiHost = {
    "apm": "https://historicaldata.apmcapital.ae",
    "vide": "https://historicaldata.videalpha.com",
    "betatrader": "https://historicaldata.videalpha.com",
    "goldpro": "https://grohistoricaldata.devacms.com"
}

